
import Vue from 'vue';

import { faFacebookF, faYoutube, faLinkedinIn, faInstagram, faTwitter, faTiktok } from '@delfi.lt/fa-kit/icons/modules/classic/brands';

interface Computed {
  sharingLinks: {
    facebook: {
      enabled: boolean;
      href: string;
    };
    youtube: {
      enabled: boolean;
      href: string;
    };
    linkedin: {
      enabled: boolean;
      href: string;
    };
    instagram: {
      enabled: boolean;
      href: string;
    };
    tiktok: {
      enabled: boolean;
      href: string;
    };
  };
}

export default Vue.extend<unknown, unknown, Computed, unknown>({
  data() {
    return {
      faFacebookF,
      faYoutube,
      faLinkedinIn,
      faInstagram,
      faTwitter,
      faTiktok,
    };
  },
  computed: {
    sharingLinks() {
      return this.$channelConfig('socialLinks');
    },
  },
});
